<template>
    <div class="my-home-content5">
      <h2>携手合作共创云生态系统</h2>
      <span class="span15">Working together to create a cloud ecosystem</span>
      <router-link :to="{path:'successCase'}">
          <span class="span25" @click="go()">查看更多客户案例></span>
      </router-link>
      <div>
        <Row>
            <Col span="2"></Col>
            <Col span="20" style="padding:0 0.5rem;">
                <div class = "my-content5">
                  <template>
                      <Carousel >
                          <CarouselItem>
                              <div class="demo-carousel">
                                <div>
                                  <div class="partner">
                                    <img src="../../assets/img/zgyc.png" width="100%"  class="img1"/>
                                  </div>
                                  <div class="partner">
                                    <img src="../../assets/img/hk.png" width="100%"  class="img1"/>
                                  </div>
                                  <div class="partner">
                                    <img src="../../assets/img/dw.png" width="100%"  class="img1"/>
                                  </div>
                                  <div class="partner">
                                    <img src="../../assets/img/lyd.png" width="100%"  class="img1"/>
                                  </div>
                                 <div class="partner">
                                    <img src="../../assets/img/qax.png" width="100%"  class="img1"/>
                                  </div>
                                </div>


                                <div>
                                  <div class="partner">
                                    <img src="../../assets/img/rj.png" width="100%"  class="img1"/>
                                  </div>
                                  <div class="partner">
                                    <img src="../../assets/img/sf.png" width="100%"  class="img1"/>
                                  </div>
                                  <div class="partner">
                                    <img src="../../assets/img/wdjs.png" width="100%"  class="img1"/>
                                  </div>
                                  <div class="partner">
                                    <img src="../../assets/img/whdx.png" width="100%"  class="img1"/>
                                  </div>
                                 <div class="partner">
                                    <img src="../../assets/img/zbjt.png" width="100%" class="img1"/>
                                  </div>
                                </div>
                                <div>
                                  <div class="partner">
                                    <img src="../../assets/img/zgdz.png" width="100%"  class="img1"/>
                                  </div>
                                  <div class="partner">
                                    <img src="../../assets/img/zgjsyh.png" width="100%" class="img1"/>
                                  </div>
                                  <div class="partner">
                                    <img src="../../assets/img/zgsy.png" width="100%"  class="img1"/>
                                  </div>
                                  <div class="partner">
                                    <img src="../../assets/img/hw.png" width="100%"  class="img1"/>
                                  </div>
                                 <div class="partner">
                                    <img src="../../assets/img/zksg.png" width="100%"  class="img1"/>
                                  </div>
                                </div>
                              </div>
                          </CarouselItem>
<!--                          <CarouselItem>
                              <div class="demo-carousel"></div>
                          </CarouselItem> -->
                      </Carousel>
                  </template>
                </div>
            </Col>
            <Col span="2"></Col>
        </Row>
            <!-- <Arrow/> -->
      </div>

    </div>

</template>

<script>
    import Arrow from '@/pages/components/Arrow'
    export default {
      name: 'HomeContent4',
      components:{Arrow},
      methods:{
        go(){
          this.resetSetItem('index','5');
        }
      }
    }
</script>

<style>
  .my-home-content5{
    text-align: center;
  }
  .ivu-carousel-track {
      width: 100%;
  }
  .my-home-content5 h2{
    font-size: 0.25rem;
    margin-bottom: 0.25rem;
    letter-spacing:0.02rem;

    font-family: Nowar-CC-Warcraft-CN-Bold;
	font-weight: bold;
	font-stretch: normal;
	letter-spacing: 0px;
	color: #333333;
  }
  .span15{
	font-family: SourceHanSansCN-Light;
	font-weight: normal;
	font-stretch: normal;
	letter-spacing: 0px;
	color: #666666;
  }
  .span25{
	font-family: SourceHanSansCN-Light;
	font-weight: normal;
	font-stretch: normal;
	letter-spacing: 0px;
	color: #009bff;
  cursor: pointer;
  }
  .my-content5{
    margin-top: 0.5rem;
    margin-bottom: 0.3rem;
  }
  .content5-img{
    width: 20%;
    float:left ;
/*    padding-right: 20px; */
  }
  .partner{
     padding: 0.08rem;
    /* margin-right: 2%; */
    float: left;
    width: 20%;
    height: 1.2rem;
    line-height: 1.2rem;
    display: flex;
    /* border-style: solid; */
    margin: 0 auto;
    box-shadow: 0 0 5px #eaeff5 inset;
  }
     img{
          object-fit: contain;
    }
    .demo-carousel .partner:hover{
box-shadow: 0px 0px 10px #8888;
    cursor: pointer;
  }
  .ivu-carousel-dots-inside {
    display: block;
    position: inherit;
    bottom: -10px;
}
.ivu-carousel-dots li button{
	background-color: #009bff;
}

</style>



// WEBPACK FOOTER //
// src/pages/home-content/HomeContent5.vue